import { simReducer } from './simulationReducer';

const simulationReducer = simReducer('INVESTMENT_MIX_', ['distribution']);

const initialState = {
  fetched: false,
  allocations: {},
  simulation: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'INVESTMENT_MIX_ALLOCATIONS_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, {
          fetched: true,
          allocations: Object.assign({}, state.allocations, { [action.payload.riskLevel]: action.payload.data }),
        });
      } else {
        return Object.assign({}, state, { fetched: true, data: null });
      }
    case 'INVESTMENT_MIX_SIMULATION_STARTED':
    case 'INVESTMENT_MIX_SIMULATION_FINISHED':
      return Object.assign({}, state, { simulation: simulationReducer(state.simulation, action) });
    default:
      return state;
  }
};
